module.exports = __webpack_public_path__ + "img/booking.1473d11b.svg";